import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto realmente funciona?',
    a: 'Más de 10,000 personas han comprobado estas recetas. Además tienes 60 días de garantía total — si no funciona, te devolvemos todo.'
  }, {
    q: '¿Puedo usarlo si estoy tomando medicamentos?',
    a: 'Sí. El libro incluye una sección de seguridad y contraindicaciones. Siempre recomendamos informar a tu médico sobre los cambios.'
  }, {
    q: '¿Es complicado preparar las recetas?',
    a: 'La mayoría se prepara en menos de 10 minutos con ingredientes que ya tienes en casa.'
  }, {
    q: '¿Y si no tengo tiempo?',
    a: 'El Bono 2 incluye un protocolo de 7 días de inicio rápido — diseñado para personas ocupadas.'
  }, {
    q: '¿Es seguro para personas mayores?',
    a: 'Hay un bono específico de recetas adaptadas para adultos mayores.'
  }, {
    q: '¿Cómo recibo el libro?',
    a: 'Es 100% digital. Recibes acceso inmediato por email después de tu compra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-ancestral-cream py-16 md:py-24 text-ancestral-dark" data-id="element-157">
      <div className="container mx-auto px-4" data-id="element-158">
        <div className="max-w-3xl mx-auto" data-id="element-159">
          <FadeIn data-id="element-160">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-ancestral-green mb-12 text-center" data-id="element-161">
              Preguntas Frecuentes
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-162">
            {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-163">
                <div className={`border border-ancestral-gold/30 rounded-xl overflow-hidden bg-white transition-all duration-300 ${openIndex === index ? 'shadow-md' : 'shadow-sm'}`} data-id="element-164">
                  <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-165">
                    <span className="font-bold text-lg text-ancestral-green pr-4" data-id="element-166">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 text-ancestral-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-167" />
                  </button>
                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-168">
                    <p className="text-ancestral-dark/80 text-lg" data-id="element-169">{faq.a}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}